import type { DifficultyLevel } from "./types";

/** Stars earned every time an activity is completed at this difficulty. */
export const STARS_PER_DIFFICULTY: Record<DifficultyLevel, number> = {
  easy: 1,
  medium: 2,
  hard: 3,
};

export function starsForDifficulty(difficulty: DifficultyLevel): number {
  return STARS_PER_DIFFICULTY[difficulty];
}

export function formatStarAmount(amount: number): string {
  if (amount === 1) return "1 star";
  return `${amount} stars`;
}

export function formatStarReward(difficulty: DifficultyLevel): string {
  const amount = starsForDifficulty(difficulty);
  return `+${amount} ${amount === 1 ? "star" : "stars"}`;
}
